export default __webpack_public_path__ + "static/media/alert.25dfeaea.svg";